import {useMemo} from "react";

import {Organization} from "../../../types/Organization";
import {filterOrganizations} from "../model/filterOrganizations";
import {sortOrganizations} from "../model/sortOrganizations";

type UseOrganizationListViewProps = {
  organizations: Organization[];
  searchTerm: string;
  selectedGroup: string;
  sortColumn: string;
  sortOrder: "asc" | "desc";
};

export const useOrganizationListView = ({
  organizations,
  searchTerm,
  selectedGroup,
  sortColumn,
  sortOrder,
}: UseOrganizationListViewProps) => {
  const filteredOrganizations = useMemo(() => {
    return filterOrganizations({
      organizations,
      searchTerm,
      selectedGroup,
    });
  }, [organizations, searchTerm, selectedGroup]);

  const sortedOrganizations = useMemo(() => {
    return sortOrganizations({
      organizations: filteredOrganizations,
      sortColumn,
      sortOrder,
    });
  }, [filteredOrganizations, sortColumn, sortOrder]);

  return {
    filteredOrganizations,
    sortedOrganizations,
  };
};
